import React, { Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { canPlayInTournament, canRegisterInTournament, canUnregisterInTournament } from './helpers/sortTournament';
import { closeDialog, openDialog } from '../../../../../../../store/actionCreators/dialog';
import { selectCasinoTournament } from '../../../../../../../store/actionCreators/tournaments';
import { requestTournamentCasinoRegister, requestTournamentCasinoUnregister } from '../../../../../../../store/actionCreators/tournamentCasinoRegister';
import { getSelectedTournamentCasino, getTournaments, getCurrentAccount } from '../../../../../../../store/selectors';
import { getTournamentBuyinInfo } from './helpers/getTournamentBuyinInfo';
import { formatCurrency } from '../../../../../../../helpers/format';
import moment from 'moment';
import classNames from 'classnames';
import '../../../../../../../assets/stylesheets/TournamentCasino/TournamentCasinoRow.scss';

const TournamentCasinoRow = ({
  tour, 
  selected, 
  renderAfter, 
  onPlay,
  onRegister,
  onUnregister,
  confirmRegister,
  confirmUnregister,
  onLobby,
  onClick,
  onClose
}) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const canPlay = canPlayInTournament(tour);
  const canRegister = canRegisterInTournament(tour);
  const canUnregister = canUnregisterInTournament(tour);
  const selectedTournamentCasino = useSelector(getSelectedTournamentCasino);
  const {chipValue} = getTournamentBuyinInfo(tour);
  const game = tour.tournamentGames[0];
  const sitngo = tour.tournamentType === 'sitngo';
  const currency = tour.buyIn.currency;
  const buyIn = tour.buyIn.buyin
  const prizePool = formatCurrency(tour.prizePool.value, 'en', currency);
  const startsAt = sitngo ? 'SNG' : moment(tour.startDate).format('MM.D HH:mm');
  const my = tour.playerStatus !== 'notRegistered';
  const showFullInfo = true;

  const classes = classNames('tournaments-casino__elem', {
    'tournaments-casino__elem--my': my,
    'tournaments-casino__elem--selected': selected === tour.tournamentId,
  });

  const selectTournamentCasino = useCallback((tournamentId) => {
    if(selectedTournamentCasino && selectedTournamentCasino.selectedId === tournamentId ) {
      dispatch(selectCasinoTournament({ selectedId: null}))
    } else {
      dispatch(selectCasinoTournament({ selectedId: tournamentId}))
    }
  }, [selectedTournamentCasino]);

  const onGameClickHandler = ( tour) => {
    onClick(tour);
    // dispatch(selectCasinoTournament({ selectedId: tour.tournamentId}));
  };

  const tourContent = (   
    <Fragment>
      <span className="tournaments-casino__elem-title">{tour.tournamentName}</span>
      <div className="tournaments-casino__elem-info-text-wrapper">
          {!showFullInfo && 
            <>
              <span>{`${t('bet')}: ${tour.minBet} `}</span>
              <span>{`${t('pool')}: ${prizePool}`}</span>
            </>
          }
          {showFullInfo && (<React.Fragment>
            <div className="tournaments-casino__elem-info-text-top">
               <span> {`${startsAt} ${buyIn ? `| ${t('tournaments.buyin')} :` : ''}`}</span> 
               <div className="tournaments-casino__elem-info-buyin-wrapper">
                 {buyIn ? chipValue() : ''}
               </div>
            </div>
            {/* TO DO for dynamic tournament type ---- freerol */}
            <span className="tournaments-casino__elem-info-text-bottom">{`${buyIn ? "" : `${t('tournaments.freerol')} |`} ${t('tournaments.enrolled')}: ${tour.enrolled}`}</span>
          </React.Fragment>)}
      </div>
    </Fragment>
  );

  const callbacks = { onRegister, onClick, onLobby, onPlay, onUnregister, onGameClickHandler, onClose };

  return (
    <li className={classes} key={tour.tournamentId} onClick={() => selected === tour.tournamentId ? false : onGameClickHandler(tour)}>
      <div className="tournaments-casino__elem-left">
        <div className="tournaments-casino__elem-image-wrapper">
          <img className="tournaments-casino__elem-image" src={!!game ? game.thumbnail : ''} />
        </div>
      </div>
      <div className="tournaments-casino__elem-right">
        <div className='tournaments-casino__elem-info-wrapper'>
          {tourContent}
        </div>

      { canRegister &&
        <button className={`tournaments-casino__elem-button tournaments-casino__elem-button--${tour.tournamentState}`} onClick={() => onRegister(tour)}>
          {t(`tournaments.${tour.tournamentState}`)}
        </button>
      }
      { canUnregister && !canPlay &&
        <button className="tournaments-casino__elem-button tournaments-casino__elem-button--unreg" onClick={() => onUnregister(tour)}>
          {t('tournaments.unreg')}
        </button>
      }
      {canPlay && 
        <button className="tournaments-casino__elem-button tournaments-casino__elem-button--play" onClick={() => onPlay(tour)}>
          {t('tournaments.play')}
        </button>
      }
      {!canPlay && !canUnregister && !canRegister && 
        <button className="tournaments-casino__elem-button tournaments-casino__elem-button--lobby" onClick={() => onLobby(tour)}>
          {t('tournaments.lobby')}
        </button>
      }
      </div>   
      {renderAfter ? renderAfter(tour, selected, callbacks) : false}
    </li>
  );
};


export default TournamentCasinoRow;